(function(window, tscProjThemeFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.TscProjTheme = tscProjThemeFactory(window, window.$, window.Q, namespace.playerConfiguration);
})(this, function(window, $, Q, playerConfiguration) {
   'use strict';

   var TscProjTheme = function(themeUri) {
      var _readyPromise = null;
      var _themeJson = {};

      var webConnector = playerConfiguration.getWebConnector();
      if (webConnector) {
         _readyPromise = webConnector.getModule('theme').then(function(module) {
            return module.getThemeByUri(themeUri).then(function(theme) {
               _themeJson = theme.data;
               return _themeJson;
            });
         });
      } else {
         _readyPromise = Q.reject('TscProjTheme: webconnector player configuration required to load TSC proj theme');
      }

      return Object.defineProperties({}, {
         ready: {
            get: function() {
               return _readyPromise;
            }
         },
         theme: {
            get: function() {
               return _themeJson;
            }
         }
      });
   };

   return {
      create: TscProjTheme
   };
});
